.header {
    margin-top: 0.5rem;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    font-weight: 600;
    font-size: 1.25rem;
}
